import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    allApplications: [],
    tagsList: [],
    applicationsCategory: null,
    environmentTypes: []
}

const myAppSlice = createSlice({
    name: "myAppSlice",
    initialState,
    reducers: {
        allApplicationList: (state, action) => {
            state.allApplications = action.payload;
        },
        myTagsList: (state, action) => {
            state.tagsList = action.payload;
        },
        applicationsCategory: (state, action) => {
            state.applicationsCategory = action.payload.data;
        },
        saveEnvironmentTypes: (state, action) => {
            state.environmentTypes = action.payload.data;
        }

    }
});

export const { allApplicationList, myTagsList, applicationsCategory, saveEnvironmentTypes } = myAppSlice.actions;
export default myAppSlice.reducer;